<template>
  <div class="page bg-gray page-flex" :class="entity.isVerify == 0?'pb-fixed-btn':''">
    <backTitleBar  :rightText="rightText"></backTitleBar>
    <div class="pd-025 bg-fff">
      <div class="flex supply-top-name bd-bot" style="padding-right: 0;">
        <div class="supply-label radius">{{equipment_type[entity.equipmentType]}}</div>
        <div class="flex1 color-333">{{entity.shopName}}</div>
        <div
          class="ml-20"
          :class="entity.isVerify == '0'?'color-org':'color-000'"
          v-if="!isCabinetToolBuyerRole"
        >{{entity.isVerify == '0'?'待确认':"已处理"}}</div>
      </div>
      <div class="pd-250">
        <div class="flex-between fs-28 color-999">
          <div>补货人：{{entity.linkName}}</div>
          <div>{{entity.createTime}}</div>
        </div>
        <div v-if="entity.equipmentType == 'rfid'">
          <!---RFID柜---->
          <div class="flex-center mt-30 fs-28">
            <div
              class="mr-50"
              :class="entity.addTypeCount && entity.addTypeCount != 0 ?'color-org font-bold':'color-999'"
              v-if="!isCabinetToolBuyerRole"
            >补货品种：{{entity.addTypeCount}}</div>
            <div
              :class="entity.minusTypeCount && entity.minusTypeCount != 0?'color-main font-bold':'color-999'"
            >取货品种：{{entity.minusTypeCount}}</div>

            <div
                    class="mr-50" style="margin-left: 10px"
                    :class="entity.addTypeCount && entity.addTypeCount != 0 ?'color-org font-bold':'color-999'"
                    v-if="!isCabinetToolBuyerRole"
            >  补货金额：{{totalPrice()}}</div>
          </div>
          <div class="flex-center mt-8 fs-28">
            <div
              class="mr-50"
              :class="entity.addNum && entity.addNum != 0 ?'color-org font-bold':'color-999'"
              v-if="!isCabinetToolBuyerRole"
            >补货数量：{{entity.addNum}}</div>
            <div
              :class="entity.minusNum && entity.minusNum != 0?'color-main font-bold':'color-999'"
            >取货数量：{{entity.minusNum}}</div>
          </div>

        </div>
        <div v-if="entity.equipmentType == 'weigh'">
          <!---称重柜---->
          <div class="flex-center mt-30 fs-28">
            <div
              class="mr-50"
              :class="entity.addTypeCount && entity.addTypeCount != 0 ?'color-org font-bold':'color-999'"
              v-if="!isCabinetToolBuyerRole"
            >补货品种：{{entity.addTypeCount}}</div>

            <div :class="entity.addTypeCount && entity.addTypeCount != 0?'color-org font-bold':'color-999'"
            > 补货金额：¥ {{totalPrice()}}</div>
            <div style="margin-left: 10px"
                 :class="entity.minusTypeCount && entity.minusTypeCount != 0?'color-main font-bold':'color-999'"
            >取货品种：{{entity.minusTypeCount}}</div>
            <!--                        <div class="color-warning ml-50">换绑货道：{{0}}</div>-->



          </div>
        </div>
      </div>
    </div>

    <div class="supply-tab-select mt-15">
      <div
        class="tab-item org"
        :class="chageType == 0?'color-org active':'color-999'"
        @click="doChangeType(0)"
        v-if="!isCabinetToolBuyerRole"
      >补货({{entity.addTypeCount}})</div>
      <div
        class="tab-item"
        :class="chageType == 1?'color-main active':'color-999'"
        @click="doChangeType(1)"
      >取货({{entity.minusTypeCount}})</div>
    </div>

      <div id="addStock" v-show="chageType == 0">
        <div class="table-title-box" v-if="eqType == 'rfid'">
          <div class="table-title">
            <div class="flex1">商品</div>
            <div class="w100 text-center ml-10">价格</div>
            <div class="w100 text-center ml-10">数量</div>
          </div>
        </div>
        <div class="flex1 posi-rel" v-if="eqType == 'rfid'">
          <scroller ref="scroller" :on-refresh="loadNewData" :on-infinite="loadMore">
            <div>
              <div
                v-for="(item,$index) in data"
                :key="$index"
                class="list-item"
                @click="getScrollerPosition();$router.push({name:'supplyRecordDetail',query:{batchNo:item.batchNo}})"
              >
                <div class="item-img">
                  <img :src="item.mainPicView" alt />
                </div>
                <div class="flex1">
                  <div class="fs-26 color-333">{{item.productName}}/{{item.specName}}</div>
    <!--              <div class="fs-24 color-999 flex mt-10">{{item.specName}}</div>-->
                </div>
                <div
                  class="fs-28 w100 text-center ml-10 pt-25"
                  :class="item.operateType == 'minus'?'color-main':'color-org'"
                >{{item.price}}元/{{item.specName}}</div>
                <div
                  class="fs-28 w100 text-center ml-10 pt-25"
                  :class="item.operateType == 'minus'?'color-main':'color-org'"
                >
                  <span v-if="item.operateType == 'minus'">-</span>
                  {{item.num}}
                </div>
              </div>
            </div>
          </scroller>
        </div>
        <div
          class="flex1 posi-rel pd-025"
          style="overflow-y: scroll;-webkit-overflow-scrolling: touch;;margin-bottom: 40px"
          v-else
        >
          <div
            class="card mb-10"
            v-for="(layer,$layerIndex) in curZone.zoneWayStockList"
            :key="$layerIndex"
          >
            <div class="layer-name">{{layer.layerName}}</div>
            <div class="table-title-box" style="margin: 0;padding-bottom: 0;">
              <div class="table-title">
                <div class="flex1">商品</div>
                <div class="w130 text-center ml-10" style="line-height: 1.1"><span>货道<br/>标准重量</span></div>
    <!--            <div class="w130 text-center ml-10">价格</div>-->
                <div class="w130 text-center ml-10" style="line-height: 1.1">识别数量<br/>商品单价</div>
                <div class="w130 text-center ml-10" style="line-height: 1.1">手工数量<br/>变化重量</div>
              </div>
            </div>
            <div
              v-for="(item,$index) in layer.zoneWayItemList"
              :key="$index"
              class="list-item pd-250"
              @click="getScrollerPosition();$router.push({name:'supplyRecordDetail',query:{batchNo:item.batchNo}})"
            >
              <div class="item-img">
                <img :src="item.mainPicView" alt />
              </div>
              <div class="flex1">
                <div class="fs-26 color-333">{{item.productName}}/{{item.specName}}</div>
    <!--            <div class="fs-24 color-999 flex mt-10">{{item.specName}}</div>-->
              </div>
              <div
                class="fs-28 w100 text-center"
                :class="item.operateType == 'minus'?'color-main':'color-org'"
              ><span style="font-weight: bold;font-size:16px">{{item.wayCode}}</span>
                <br/>{{item.weight}}g

              </div>
              <div
                class="fs-28 w130 text-center ml-10"
                :class="item.operateType == 'minus'?'color-main':'color-org'"
              >
                <span v-if="item.operateType == 'minus'">-</span>
                <span v-if="item.isWeightCalc == 1" style="font-weight: bold;font-size:16px">{{item.num / 1000}}kg</span>
                <span v-else style="font-weight: bold;font-size:16px">{{item.num}}</span>
                <span
                        class="fs-28 w130 text-center ml-10 pt-25"
                        :class="item.operateType == 'minus'?'color-main':'color-org'"
                ><br/>{{item.specialPrice}}元
                  <!--              <span>/{{item.isWeightCalc == 1?'kg':item.unitName}}</span>-->
                </span>
              </div>
              <div class="fs-28 w130 text-center ml-10">
                  <span>
                      <input
                              class="spacer v-txt"
                              type="number"
                              :disabled="entity.isVerify == '1'?true:false"
                              v-model="item.afterNums"
                              placeholder="数量"
                      />
                  </span>
                  <span style="font-weight: bold;font-size:16px">
                    {{item.wayTotalWeight}}g
                  </span>
              </div>


            </div>
          </div>
        </div>
      </div>


        <div id="minStock" v-show="chageType == 1">
          <div class="table-title-box" v-if="eqType == 'rfid'">
            <div class="table-title">
              <div class="flex1">商品</div>
              <div class="w100 text-center ml-10">价格</div>
              <div class="w100 text-center ml-10">数量</div>
            </div>
          </div>
          <div class="flex1 posi-rel" v-if="eqType == 'rfid'">
            <scroller ref="scroller" :on-refresh="loadNewData" :on-infinite="loadMore">
              <div>
                <div
                        v-for="(item,$index) in data"
                        :key="$index"
                        class="list-item"
                        @click="getScrollerPosition();$router.push({name:'supplyRecordDetail',query:{batchNo:item.batchNo}})"
                >
                  <div class="item-img">
                    <img :src="item.mainPicView" alt />
                  </div>
                  <div class="flex1">
                    <div class="fs-26 color-333">{{item.productName}}/{{item.specName}}</div>
                    <!--              <div class="fs-24 color-999 flex mt-10">{{item.specName}}</div>-->
                  </div>
                  <div
                          class="fs-28 w100 text-center ml-10 pt-25"
                          :class="item.operateType == 'minus'?'color-main':'color-org'"
                  >{{item.price}}元/{{item.specName}}</div>
                  <div
                          class="fs-28 w100 text-center ml-10 pt-25"
                          :class="item.operateType == 'minus'?'color-main':'color-org'"
                  >
                    <span v-if="item.operateType == 'minus'">-</span>
                    {{item.num}}
                  </div>
                </div>
              </div>
            </scroller>
          </div>
          <div
                  class="flex1 posi-rel pd-025"
                  style="overflow-y: scroll;-webkit-overflow-scrolling: touch;margin-bottom: 40px"
                  v-else
          >
            <div
                    class="card mb-10"
                    v-for="(layer,$layerIndex) in curZoneMin.zoneWayStockList"
                    :key="$layerIndex"
            >
              <div class="layer-name">{{layer.layerName}}</div>
              <div class="table-title-box" style="margin: 0;padding-bottom: 0;">
                <div class="table-title">
                  <div class="flex1">商品</div>
                  <div class="w130 text-center ml-10" style="line-height: 1.1">货道<br/>标准重量</div>
                  <!--            <div class="w130 text-center ml-10">价格</div>-->
                  <div class="w130 text-center ml-10" style="line-height: 1.1">识别数量<br/>商品单价</div>
                  <div class="w130 text-center ml-10" style="line-height: 1.1">手工数量<br/>变化重量</div>
                </div>
              </div>
              <div
                      v-for="(item,$index) in layer.zoneWayItemList"
                      :key="$index"
                      class="list-item pd-250"
                      @click="getScrollerPosition();$router.push({name:'supplyRecordDetail',query:{batchNo:item.batchNo}})"
              >
                <div class="item-img">
                  <img :src="item.mainPicView" alt />
                </div>
                <div class="flex1">
                  <div class="fs-26 color-333">{{item.productName}}/{{item.specName}}</div>
                  <!--            <div class="fs-24 color-999 flex mt-10">{{item.specName}}</div>-->
                </div>
                <div
                        class="fs-28 w100 text-center"
                        :class="item.operateType == 'minus'?'color-main':'color-org'"
                ><span style="font-weight: bold;font-size:16px">{{item.wayCode}}</span>
                  <br/>{{item.weight}}g
                </div>
                <div
                        class="fs-28 w130 text-center ml-10"
                        :class="item.operateType == 'minus'?'color-main':'color-org'"
                >
                  <span v-if="item.operateType == 'minus'">-</span>
                  <span v-if="item.isWeightCalc == 1" style="font-weight: bold;font-size:16px">{{item.num / 1000}}kg</span>
                  <span v-else style="font-weight: bold;font-size:16px">{{item.num}}</span>
                  <span
                          class="fs-28 w130 text-center ml-10 pt-25"
                          :class="item.operateType == 'minus'?'color-main':'color-org'"
                  ><br/>{{item.specialPrice}}元
                    <!--              <span>/{{item.isWeightCalc == 1?'kg':item.unitName}}</span>-->
                </span>
                </div>
                <div class="fs-28 w130 text-center ml-10">

                    <span>
                            <input
                                    class="spacer v-txt"
                                    type="number"
                                    :disabled="entity.isVerify == '1'?true:false"
                                    v-model="item.afterNums"
                                    placeholder="数量"
                            />
                        </span>
                        <span style="font-weight: bold;font-size:16px">
                          {{item.wayTotalWeight}}g
                        </span>
                </div>


              </div>
            </div>
          </div>
       <div>
       </div>
        </div>

    <div class="fixed-bot" v-if="entity.isVerify == 0 && !isCabinetToolBuyerRole">
      <div class="btn click" @click="confirm">确认补货记录</div>
    </div>
  </div>
</template>

<script>
import backTitleBar from '@/components/titleBar/backTitleBar'
import initData2 from '@/mixins/initData'
import { initData } from '@/api/baseData'
import { confirmReplenish, getReplenishDetail } from '@/api/product'
import {syncShopItemStock} from "@/api/shop"
export default {
  name: 'detail',
  components: { backTitleBar },
  mixins: [initData2],
  data() {
    return {
      equipment_type: {
        spring: '弹簧柜',
        rfid: 'RFID柜',
        consign: '格子柜',
        weigh: '称重柜'
      },
      rightText:{
        color:'#333',
        fontSize:'.28rem',
        text:'查看库存',
        method: this.toStockDet
      },
      entity: {},
      totalAmount:0,
      batchNo: null,
      img: require('../../assets/images/shopHome/tag6.png'),
      chageType: 0,
      curZone: [],
      curZoneMin: [],
      isCabinetToolBuyerRole:
        this.$store.state.user.isCabinetToolBuyerRole || false
    }
  },
  created() {
    this.batchNo = this.$route.query.batchNo
    this.eqType = this.$route.query.eqType
    if (this.isCabinetToolBuyerRole) {
      this.chageType = 1
    }
    if (this.eqType != 'rfid') {
      this.getAddData();
      //this.getMinData();
    }
  },
  methods: {
    totalPrice() {

      // if(this.curZone.zoneWayStockList){
      //   this.curZone.zoneWayStockList.forEach(item1=>{
      //     if(item1){
      //       item1.zoneWayItemList.forEach(det=>{
      //         this.totalAmount += Number(det.totalAmount).toFixed(2);
      //       })
      //     }
      //
      //   })
      // }

      return Number(this.totalAmount).toFixed(2);
    },
    beforeInit() {

      this.limit = 1000;
      this.params = {
        page: this.page,
        limit: this.limit,
        batchNo: this.batchNo,
        chageType: this.chageType
      }
      console.info("--------1111")
      this.url = 'item/stockLog/qryStockLogDetail'
      let query = this.pageInfo
      for (var key in query) {
        if (query[key]) {
          this.params[key] = query[key]
        }
      }
      return true
    },
    init(done) {

      if (!this.beforeInit()) {
        return
      }
     // this.$refs.scroller.finishPullToRefresh()
      return new Promise((resolve, reject) => {
        initData(this.url, this.params)
          .then(res => {
            console.info("--------2222")
            this.loading = false
            done()
            this.total = Number(res.data.itemList.total)
            if ((this.page - 1) * this.limit >= this.total) {
              this.noDate = true
            } else {
              this.noDate = false
            }

            // 判断是下拉刷新还是上拉加载（这一步也是比较巧妙的，当然也很好理解）
            if (this.page == 1) {
              this.data = res.data.itemList.records
              this.entity = res.data
              res.data.itemList.records.forEach(item1=>{
                this.totalAmount += Number(item1.specialPrice).toFixed(2)*Number(item1.num).toFixed(2);
              })



            } else {
              this.data = this.data.concat(res.data.itemList.records);
              res.data.itemList.records.forEach(item1=>{
                this.totalAmount += Number(item1.specialPrice).toFixed(2)*Number(item1.num).toFixed(2);
              });



            }

            console.log(this.data)
          })
          .catch(err => {
            this.noDate = true //防止死循环
            this.loading = false
            done()
            reject(err)
          })
      })
    },
    getAddData() {
      let that = this;
      let params = {
        page: 1,
        limit: 100,
        batchNo: this.batchNo,
        chageType: this.chageType
      }
      getReplenishDetail(params).then(res => {
        this.entity = res.data
        if (res.data.zoneStockList.length != 0) {
          this.curZone = res.data.zoneStockList[0];

          res.data.zoneStockList.forEach(item => {
            if (item) {
              that.totalAmount = 0
              this.curZone.zoneWayStockList.forEach(item1 => {
                if (item1) {


                  item1.zoneWayItemList.forEach(det => {

                    if(det.modifyNum != null){
                      det.afterNums = det.modifyNum;
                    }else{
                      det.afterNums = '';
                    }

                    that.totalAmount += Number(det.specialPrice).toFixed(2) * Number(det.num).toFixed(2);
                    if (det.totalAmount) {

                      //that.totalAmount = that.totalAmount+parseFloat(det.totalAmount);//parseFloat(that.totalAmount) + parseFloat(det.totalAmount).toFixed(2);

                    }

                  })
                }

              })
            }
          });


        } else {
          this.curZone = {
            zoneWayStockList: []
          }
        }
      })
    },
    getMinData() {
      let that = this;
      let params = {
        page: 1,
        limit: 100,
        batchNo: this.batchNo,
        chageType: this.chageType
      }
      getReplenishDetail(params).then(res => {
        this.entityMin = res.data
        if (res.data.zoneStockList.length != 0) {
          this.curZoneMin = res.data.zoneStockList[0];


          if(this.curZoneMin){
            this.curZoneMin.zoneWayStockList.forEach(item1=>{

              if(item1){
                item1.zoneWayItemList.forEach(det=>{
                  if(det.modifyNum != null){
                    det.afterNums = det.modifyNum;
                  }else{
                    det.afterNums = '';
                  }
                  if(det.totalAmount){
                    that.totalAmountMin = that.totalAmount+parseFloat(det.totalAmount);//parseFloat(that.totalAmount) + parseFloat(det.totalAmount).toFixed(2);

                  }

                })
              }

            })
          }


        } else {
          this.curZoneMin = {
            zoneWayStockList: []
          }
        }
      })
    },
    toStockDet(){
      this.$router.push({
        name: "equipmentStock",
        query: {shopId:this.entity.shopId },
      });
    },
    sysnStock(){
      let that = this;
      syncShopItemStock({ shopId: that.entity.shopId }).then(res => {
        if (res.code === 0) {
          that.$Message.success('正在同步中...')
          setTimeout(() => {
            that.$router.push({
              name: "equipmentStock",
              query: {shopId:that.entity.shopId },
            });

          }, 2000);
        }
      })
    },
    doChangeType(type) {
      this.$emit('chageType', type)
      this.chageType = type
      if (this.eqType == 'rfid') {
        this.handleQuery()
      } else if(type == '0' && this.curZone.length == 0){
        this.getAddData()
      }else if(type == '1' && this.curZoneMin.length == 0){
        this.getMinData()
      }


    },

    confirm() {
      let _this = this
      let params ={
        batchNo: this.entity.batchNo,
        detailBoList:[]
      }
      if(this.curZone != null && this.curZone.zoneWayStockList!=null){
        this.curZone.zoneWayStockList.forEach((item1) => {

          item1.zoneWayItemList.forEach((item) => {
                    if (item.afterNums > 0) {
                      params.detailBoList.push({
                        afterNums: item.afterNums,
                        beforNums: item.num,
                        changeType: '0',
                        itemId: item.itemId,
                        itemSkuId: item.itemSkuId,
                        itemSkuStockId:item.itemSkuStockId,
                        shopId:item.shopId,
                        wayId: item.wayId,
                      })
                    } else {

                    }
                  })
        })
      }
      if(this.curZoneMin != null && this.curZoneMin.zoneWayStockList != null){
        this.curZoneMin.zoneWayStockList.forEach((item1) => {
          item1.zoneWayItemList.forEach((item) => {
            if (item.afterNums > 0) {
              params.detailBoList.push({
                afterNums: item.afterNums,
                beforNums: item.num,
                changeType: '1',
                itemId: item.itemId,
                itemSkuId: item.itemSkuId,
                itemSkuStockId:item.itemSkuStockId,
                shopId:item.shopId,
                wayId: item.wayId,
              })
            } else {

            }
          })
        })
      }



      this.$dialog
        .alert({
          title: '提示',
          message: '是否确定补货',
          showCancelButton: true
        })
        .then(() => {
          //点击确认按钮后的调用
          confirmReplenish(params).then(res => {
            _this.$toast('操作成功')
            _this.$store.state.updateSupplyRecordList = true
            _this.$router.back()
          })
        })
        .catch(() => {
          //点击取消按钮后的调用
          console.log('cancel')
        })
    }
  }
}
</script>

<style scoped lang="scss">
.list-item {
  margin: 0 0.24rem;
  padding: 0.24rem;
  display: flex;
  background: #fff;
  &.pd-250 {
    padding: 0.25rem 0;
  }
  .item-img {
    width: 0.9rem;
    height: 0.9rem;
    margin-right: 0.12rem;
  }
  &:last-child {
    padding-bottom: 0.24rem;
    border-bottom-left-radius: 0.12rem;
    border-bottom-right-radius: 0.12rem;
  }
  &:first-child {
    padding-top: 0;
  }
}
.layer-name {
  width: 1.2rem;
  height: 0.5rem;
  background: $main-color;
  border-radius: 0 0.12rem 0.12rem 0;
  font-size: 0.28rem;
  text-align: center;
  line-height: 0.5rem;
  color: #fff;
}
.table-title-box {
  margin: 0 0.24rem;
  padding: 0.2rem;
  background: #fff;
  border-top-left-radius: 0.12rem;
  border-top-right-radius: 0.12rem;
}
.spacer {
  flex: 1;
}
.v-txt {
  color: #333;
  width: 100%;
  border: 1px solid #aaa;
  border-radius: 2px;
  padding: 0 5px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// detail.vue?39fdc470